import React from 'react';
import { Navigate } from 'react-router-dom';
import FormTemplate from '../../components/templates/formTemplate/formTemplate';
import ListTablePage from '../../components/templates/listTableTemplate/listTableTemplate';
import viewBillingTransactions from '../../config/viewBillingTransactions';
import viewBillingTransactionsMonthly from '../../config/viewBillingTransactionsMonthly';
import withPermission from '../../utils/withPermission';
import permissionTypes from '../../components/atoms/permissionsGate/permissionTypes';
import routes, { getRoute } from '../../routes/route';

export const clientPortalRoutes = [
  {    
    path: (routes.BILLING_TRANSACTIONS_SUMMARY_DIRECT.path),
    element: withPermission(
      [permissionTypes.CLIENT_PORTAL],
      <FormTemplate configFile={viewBillingTransactionsMonthly} />
    ),
  },
  {
    path: (routes.BILLING_TRANSACTIONS_DETAIL.path),
    element: withPermission(
      [permissionTypes.CLIENT_PORTAL],
      <ListTablePage configFile={viewBillingTransactions} />
    ),
  },
   {
     index: true,
     element: <Navigate to="billingTransactionsSummary" replace />,
   },
];